/**
 * Unified analytics tracking - sends to both Mixpanel AND PostHog
 * This ensures we collect data in both systems during migration/comparison
 */

import sendToMixpanel from './sendToMixpanel'
import { sendEventToPosthog } from '../posthog-client'
import { IS_PROD } from '../constant'

/**
 * Send event to both Mixpanel and PostHog
 * @param eventName - Event name (use constants from constant.ts)
 * @param eventProperties - Event properties
 * @param userId - User ID (optional)
 */
const sendToBothAnalytics = async (
  eventName: string,
  eventProperties?: Record<string, any>,
  userId?: string,
) => {
  if (!IS_PROD) {
    // Not send to Mixpanel and PostHog in non-prod environments
    return
  }
  try {
    // Send to Mixpanel (existing)
    await sendToMixpanel(eventName, eventProperties, userId)
  } catch (_) {
    // Silently fail if Mixpanel tracking fails
  }

  // Send to PostHog (new)
  try {
    sendEventToPosthog(eventName, {
      ...eventProperties,
      distinct_id: userId,
      $user_id: userId,
    })
  } catch (_) {
    // Silently fail if PostHog tracking fails
  }
}

export default sendToBothAnalytics
